import { ButtonHTMLAttributes, forwardRef } from "react";

import { ProductSwitcherIcon } from "@/assets/icons";
import Tooltip from "@/components/ui/tooltip";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

type ProductSwitcherTriggerProps = {
  isActive: boolean;
  sidebarMenu?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const ProductSwitcherTrigger = forwardRef<
  HTMLButtonElement,
  ProductSwitcherTriggerProps
>(({ isActive, sidebarMenu, ...rest }, ref) => (
  <Button
    {...rest}
    ref={ref}
    variant="secondary"
    aria-label="Switch Product"
    data-testid="product-popover-trigger"
    className={twMerge(
      "!p-0 rounded-lg hover:bg-teal-50 border-0",
      isActive && "bg-teal-50",
      sidebarMenu ? "w-[231px] justify-start" : "h-10 w-10 justify-center"
    )}
  >
    <Tooltip
      disable={sidebarMenu}
      content="Switch Product"
      position="right"
      key="Switch Product"
    >
      <div className="flex items-center justify-center">
        <ProductSwitcherIcon
          className={twMerge(
            "fill-dim-gray hover:fill-teal-500 w-10 h-10 shrink-0 p-2",
            isActive && "fill-teal-500"
          )}
        />
        <span
          className={twMerge(
            "whitespace-pre text-sm font-medium",
            !sidebarMenu && "opacity-0 translate-x-28 overflow-hidden hidden",
            isActive ? "text-black font-bold" : "text-dim-gray"
          )}
        >
          Switch Product
        </span>
      </div>
    </Tooltip>
  </Button>
));

ProductSwitcherTrigger.displayName = "ProductSwitcherTrigger";

export default ProductSwitcherTrigger;
